import React from 'react';
import DefaultModal from '../../../../../components/Modal/DefaultModal';
import { Table } from 'reactstrap';
import ReactLoader from 'components/Loader';
import { Row } from 'reactstrap';

const ListAccountsModal = ({
  isModalAccountsOpen,
  setIsModalAccountsOpen,
  isSearching,
  modalAccounts,
  handleEditAccount
}) => {
  return (
    <DefaultModal
      show={isModalAccountsOpen}
      onModalToggle={setIsModalAccountsOpen}
      title={'Escolha uma conta'}
      showCloseButton={false}
      modalContainerClasses=""
    >
      <div>
        {isSearching ? (
          <Row className="justify-content-md-center">
            <ReactLoader />
          </Row>
        ) : (
          <Table
            bordered
            hover
            responsive
            size="sm"
            className="text-center align-middle"
          >
            <thead>
              <tr>
                <th className="text-center align-middle" style={{ width: 50 }}>
                  #
                </th>
                <th className="text-center align-middle">Nome</th>
              </tr>
            </thead>
            <tbody>
              {modalAccounts.map((acc, idx) => {
                console.log('Olha o modalAccounts', acc);
                return (
                  <tr key={acc.accountId}>
                    <td className="text-center align-middle">{idx + 1}</td>
                    <td
                      className="text-center align-middle"
                      style={{
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }}
                      onClick={() => handleEditAccount(acc)}
                      title="Clique para ver detalhes"
                    >
                      {acc.label}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    </DefaultModal>
  );
};

export default ListAccountsModal;
